<!-- Расчёт создаётся: шапка «Стоимости поставки» и ход работы ИИ -->
<div class="calc-progress-page" *ngIf="processing && progress as p; else calcTpl">
  <header class="calc-progress-page__head">
    <h1>{{ t('calcSections.overview', 'Стоимость поставки') }}</h1>
    <p class="calc-progress-page__meta">
      <span>{{ t('calcSections.accountNumber', 'Учётный номер') }}: <strong>№ {{ p.id }}</strong></span>
      <span *ngIf="p.createdAt || calculation?.createdAt">{{ t('calcSections.date', 'Дата') }}: <strong>{{ (p.createdAt || calculation?.createdAt) | date:'dd.MM.yyyy HH:mm' }}</strong></span>
    </p>
  </header>

  <div class="progress-card" role="status" aria-live="polite">
    <div class="progress-card__top">
      <span class="progress-card__icon" aria-hidden="true"><span class="progress-card__spinner"></span></span>
      <div>
        <p class="progress-card__title">{{ t('public.createCalculation.pendingLead', 'Готовим расчёт') }}</p>
        <p class="progress-card__sub">{{ t('public.createCalculation.pendingHint', 'Обычно это занимает 1–3 минуты. Разделы откроются сами, как только всё будет готово.') }}</p>
      </div>
    </div>

    <!-- Сообщения сервера по порядку: пройденные — с галочкой, текущее — с индикатором -->
    <ol class="progress-steps">
      <li *ngFor="let step of p.log; let last = last" class="progress-steps__item" [class.progress-steps__item--current]="last">
        <span class="progress-steps__mark" aria-hidden="true">
          <span *ngIf="last" class="progress-steps__dot"></span>
          <svg *ngIf="!last" viewBox="0 0 20 20"><path d="M5 10.5l3.5 3.5 6.5-7"/></svg>
        </span>
        <span class="progress-steps__text">{{ step }}</span>
      </li>
    </ol>
    <span class="progress-card__bar" aria-hidden="true"></span>
  </div>
</div>

<ng-template #calcTpl>
  <div class="calc-progress-error" *ngIf="progress?.error" role="alert">{{ progress?.error }}</div>
  <!-- Админ: так этот расчёт видит клиент -->
  <div class="admin-view-note" *ngIf="isAdmin && calculation" role="note">
    <svg viewBox="0 0 20 20" aria-hidden="true"><path d="M2 10s3-5.5 8-5.5S18 10 18 10s-3 5.5-8 5.5S2 10 2 10z"/><circle cx="10" cy="10" r="2.5"/></svg>
    <span>
      {{ t('adminCalcs.viewAsClient', 'Просмотр глазами клиента') }}<ng-container *ngIf="calculation.ownerDisplayName">: <strong>{{ calculation.ownerDisplayName }}</strong></ng-container>
    </span>
  </div>
  <app-view-calculation-details
    [calculation]="calculation"
    [loading]="loading"
    [error]="error"
    [showBackButton]="!section"
    [section]="section"
    (back)="onBack()"
  >
    <!-- Десктоп: кнопка рядом с заголовком -->
    <button
      headerActions
      *ngIf="calculation && showProcess"
      type="button"
      class="process-btn"
      (click)="onProcessClick()"
    >
      {{ processLabel }}
    </button>

    <!-- Внизу «Стоимости поставки» — то же действие после того, как человек увидел все расходы -->
    <button
      overviewCta
      *ngIf="calculation && section === 'overview' && !isAdmin"
      type="button"
      class="process-btn process-btn--cta"
      (click)="onProcessClick()"
    >
      {{ processLabel }}
    </button>
  </app-view-calculation-details>

  <!-- Телефон: действие всегда под большим пальцем -->
  <div class="sticky-cta" *ngIf="calculation && showProcess">
    <button type="button" class="process-btn process-btn--block" (click)="onProcessClick()">
      {{ processLabel }}
    </button>
  </div>
</ng-template>
